<template>
    <div class="page-tabs-box">
        <el-tabs v-model="activeName" @tab-click="clickEvent">
            <el-tab-pane
                label="新增乐迷"
                name="1"
                link="/report/fans/newFans"
            ></el-tab-pane>
            <el-tab-pane
                v-if="$utils.have('/fans/report/login/list')"
                label="登录乐迷"
                name="2"
                link="/report/fans/loginFans"
            ></el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
export default {
    props: {
        name: {
            type: String,
            default: "1",
        },
    },
    data() {
        return {
            activeName: this.name,
        };
    },
    methods: {
        clickEvent(tab) {
            if (tab.$attrs.link) this.$router.push(tab.$attrs.link);
        },
    },
};
</script>

<style lang="scss" scoped>

</style>